import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import type { GiftCardGroup } from "./account-gift-card-history-component/lib";

const OPTIONS: { label: string; value: GiftCardGroup }[] = [
  { label: "Based on moments", value: "moment" },
  { label: "Festive season", value: "festive" },
];

interface GiftCardGroupToggleProps {
  value: GiftCardGroup;
  onChange: (group: GiftCardGroup) => void;
  className?: string;
}

export function GiftCardGroupToggle({ value, onChange, className }: GiftCardGroupToggleProps) {
  return (
    <View className={cn("flex flex-row gap-2", className)}>
      {OPTIONS.map((option) => {
        const isSelected = value === option.value;
        return (
          <View
            key={option.value}
            className={cn(
              "cursor-pointer rounded-full border px-4 py-2",
              isSelected
                ? "border-primary-border bg-primary-surface"
                : "border-border-medium bg-transparent",
            )}
            onClick={() => onChange(option.value)}
          >
            <Typography
              variant="label-sm"
              color={isSelected ? "brand-primary" : "foreground-intermediate"}
            >
              {option.label}
            </Typography>
          </View>
        );
      })}
    </View>
  );
}
